
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Adv05ItemDtDialog extends Serenity.EntityDialog<Adv05ItemDtRow, any> {
        protected getFormKey() { return Adv05ItemDtForm.formKey; }
        protected getIdProperty() { return Adv05ItemDtRow.idProperty; }
        protected getLocalTextPrefix() { return Adv05ItemDtRow.localTextPrefix; }
        protected getNameProperty() { return Adv05ItemDtRow.nameProperty; }
        protected getService() { return Adv05ItemDtService.baseUrl; }
        protected getDeletePermission() { return Adv05ItemDtRow.deletePermission; }
        protected getInsertPermission() { return Adv05ItemDtRow.insertPermission; }
        protected getUpdatePermission() { return Adv05ItemDtRow.updatePermission; }

        protected form = new Adv05ItemDtForm(this.idPrefix);

    }
}